import { c as _c } from "react/compiler-runtime";
interface MemeWinnerDescriptionProps {
  readonly description: string;
}
export default function MemeWinnerDescription(t0) {
  const $ = _c(2);
  const {
    description
  } = t0;
  let t1;
  if ($[0] !== description) {
    t1 = <div><p className="tw-text-iron-400 tw-mb-0 tw-text-md">{description}</p></div>;
    $[0] = description;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}